// Short git SHA of this build, injected by vite.config.js (`define`). Sent as
// X-App-Version on every request so a report or a 5xx names the exact build.
// eslint-disable-next-line no-undef
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
